export default __webpack_public_path__ + "static/Notifications-4b9a774e225a682f312fa675e938b02d.webp";